import React from 'react';
import { ErrorAlert } from '@components/error/error.display.styles';

interface ErrorDisplayProps {
  error?: Error | null;
  forGrid?: boolean;
}

export const ErrorDisplay = ({ error, forGrid }: ErrorDisplayProps) => {
  if (!error) return null;
  return (
    <ErrorAlert severity='error' $forGrid={forGrid}>
      {error.message}
    </ErrorAlert>
  );
};
